export default __webpack_public_path__ + "static/media/wallet.d723901b.svg";